import React from "react";
import PropTypes from "prop-types";
import { ListItem, ListItemIcon, ListItemText } from "material-ui/List";
import { withRouter } from "react-router-dom";

const DrawerMenuItem = props => {
  const { url, label, icon, onCloseDrawer, history } = props;

  const onClick = () => {
    if (url.charAt(0) !== "/") {
      window.location = url;
    } else {
      history.push(url);
    }
    onCloseDrawer();
  };

  return (
    <ListItem button dense onClick={onClick}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );
};

DrawerMenuItem.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  icon: PropTypes.element.isRequired
};

export { DrawerMenuItem };

export default withRouter(DrawerMenuItem);



// WEBPACK FOOTER //
// ./src/DrawerMenuItem.js